<template>
  <a-row :gutter="12">
    <a-col span="8">
      <a-alert :type="sisa_penarikan > 0 ? 'error' : 'success'" show-icon>
        <span slot="message">{{ formatCurrency("", sisa_penarikan) }}</span>
        <span slot="description"
          >Total value penarikan yang belum dijadwalkan</span
        >
      </a-alert>
      <a-card class="margin-top">
        <a-form-model ref="detailForm" :model="form" :rules="rules">
          <a-row :gutter="12">
            <!-- <a-col span="12">
              <a-form-model-item label="Bulan" prop="bulan">
                <a-month-picker
                  v-model="form.bulan"
                  format="MMMM"
                  placeholder="Select month"
                ></a-month-picker>
              </a-form-model-item>
            </a-col>
            <a-col span="12"> 
              <a-form-model-item label="Tahun" prop="tahun">
                <a-date-picker
                  v-model="form.tahun"
                  format="MM-YYYY"
                  :open="yearPicker.isOpen"
                  @panelChange="
                    (v) => {
                      yearPicker.isOpen = false;
                      form.tahun = v;
                    }
                  "
                  @openChange="
                    !yearPicker.isOpen
                      ? (yearPicker.isOpen = true)
                      : (yearPicker.isOpen = false)
                  "
                  placeholder="Select year"
                ></a-date-picker>
              </a-form-model-item>
            </a-col> -->
            <a-form-model-item label="Month-year" prop="tahun">
              <a-month-picker
                v-model="form.tahun"
                format="MM-YYYY"
                placeholder="Select year"
                @change="changeyear"
              ></a-month-picker>
            </a-form-model-item>
          </a-row>
          <a-form-model-item label="Type" prop="type">
            <a-select
              showSearch
              placeholder="Select month"
              v-model="form.type"
            >
              <a-select-option key="pokok">Pokok</a-select-option>
              <a-select-option key="bunga">Bunga</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="Value" prop="pokok" v-if="form.type=='pokok'">
            <a-input-number
              class="m-width-full m-text-align-right"
              :formatter="
                (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              "
              :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
              v-model="form.pokok"
            ></a-input-number>
          </a-form-model-item>
          <a-form-model-item label="Bunga" prop="bunga" v-if="form.type == 'bunga'">
            <a-input-number
              class="m-width-full m-text-align-right"
              :formatter="
                (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              "
              :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
              v-model="form.bunga"
            ></a-input-number>
          </a-form-model-item>
        </a-form-model>
        <template slot="actions">
          <a-button
            type="primary"
            :block="changeDetail.status ? false : true"
            :icon="changeDetail.status ? '' : 'plus'"
            @click="handleDetail"
            >{{
              changeDetail.status ? "Submit Change" : "Add Detail"
            }}</a-button
          >
          <a-button
            v-if="changeDetail.status"
            @click="handleCancel"
            type="default"
            >Cancel</a-button
          >
        </template>
      </a-card>
    </a-col>
    <a-col span="16">
      <a-card title="Detail Pembayaran">
        <a-table
          :rowKey="(record, index) => { return index; }"
          :scroll="{ x: 800 }"
          :dataSource="getDataProcessed.detail"
          :columns="columns"
          bordered
          :pagination="false"
        >
          <div slot="no" slot-scope="item, record, index">
            {{ index + 1 }}
          </div>
          <div slot="tempo" slot-scope="item, record, index">
            {{
              moment()
                .month(parseInt(item.bulan) - 1)
                .format("MMMM") +
              " - " +
              moment(item.tahun).format("YYYY")
            }}
          </div>
          <div slot="pokok" slot-scope="item, record, index">
            {{ formatCurrency("", item.pokok) }}
          </div>
          <div slot="bunga" slot-scope="item, record, index">
            {{ formatCurrency("", item.bunga) }}
          </div>
          <div slot="total" slot-scope="item, record, index">
            {{ formatCurrency("", item.total) }}
          </div>
          <a-button-group slot="action" slot-scope="item">
            <template v-if="mode !== 'Create' && item.can_edit === 'enabled'">
              <a-button @click="handleEdit(item)" icon="edit" :disabled="changeDetail.selected.id == item.id || changeDetail.status"></a-button>
              <a-button
                :disabled="changeDetail.selected.id == item.id || changeDetail.status"
                @click="handleDelete(item)"
                type="danger"
                icon="close"
              ></a-button>
            </template>
            <template v-else>
              <a-button
                :disabled="mode !== 'Create' || changeDetail.status"
                icon="edit"
                @click="handleEdit(item)"
              ></a-button>
              <a-button
                :disabled="mode !== 'Create' || changeDetail.status"
                @click="handleDelete(item)"
                type="danger"
                icon="close"
              ></a-button>
            </template>
          </a-button-group>
          <ul class="table-footer" slot="footer" slot-scope="item">
            <li>
              <span>Total Pokok</span>
              <h3>{{ formatCurrency("IDR", sum_table.total_pokok) }}</h3>
            </li>
            <li>
              <span>Total Bunga</span>
              <h3>{{ formatCurrency("IDR", sum_table.total_bunga) }}</h3>
            </li>
            <li>
              <span>Total Value</span>
              <h3>{{ formatCurrency("IDR", sum_table.total_value) }}</h3>
            </li>
          </ul>
        </a-table>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import nanoid from "nanoid";

export default {
  name: "detail",
  props: ["mode"],
  data() {
    const columns = [
      {
        title: "No",
        align: "center",
        width: 55,
        scopedSlots: { customRender: "no" },
      },
      {
        title: "Tempo Pembayaran",
        align: "left",
        width: 200,
        scopedSlots: { customRender: "tempo" },
      },
      {
        title: "Pokok",
        align: "right",
        width: 200,
        scopedSlots: { customRender: "pokok" },
      },
      {
        title: "Bunga",
        align: "right",
        width: 200,
        scopedSlots: { customRender: "bunga" },
      },
      {
        title: "Total Value",
        align: "right",
        width: 200,
        scopedSlots: { customRender: "total" },
      },
      {
        title: "Action",
        align: "center",
        width: 100,
        fixed: "right",
        scopedSlots: { customRender: "action" },
      },
    ];
    return {
      columns,
      yearPicker: {
        isOpen: false,
      },
      changeDetail: {
        selected: {},
        status: false,
      },
      form: {
        bulan: null,
        tahun: null,
        type: 'pokok',
        pokok: null,
        bunga: null,
      },
      rules: {
        bulan: [
          {
            required: true,
            message: "Please pick Bulan",
          },
        ],
        tahun: [
          {
            required: true,
            message: "Please pick Month-Year",
          },
        ],
        type: {
          required: true,
          message: "Please input Type Value",
        },
        pokok: {
          required: true,
          message: "Please input Value",
        },
        bunga: {
          required: true,
          message: "Please input Bunga",
        },
      },
    };
  },
  mixins: [CurrencyFormat],
  computed: {
    ...mapGetters(["getDataProcessed"]),
    sum_table() {
      let output = [...this.getDataProcessed.detail];

      const total_value = output.reduce(
        (sum, item) => sum + (parseInt(item.pokok) + parseInt(item.bunga)),
        0
      );

      const total_pokok = output.reduce(
        (sum, item) => sum + parseInt(item.pokok),
        0
      );

      const total_bunga = output.reduce(
        (sum, item) => sum + parseInt(item.bunga),
        0
      );

      return { total_value, total_pokok, total_bunga };
    },
    sisa_penarikan() {
      let output =
        parseFloat(this.getDataProcessed.information.value) -
        this.sum_table.total_pokok;
      return output;
    },
  },
  methods: {
    moment,
    initialState() {
      this.form = {
        bulan: null,
        tahun: null,
        type:'pokok',
        pokok: null,
        bunga: null,
      };
    },
    handleDetail() {
      this.$refs.detailForm.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }


        let tpokok = this.form.type == "pokok" && this.form.pokok ? this.form.pokok : 0;
        let tbunga = this.form.type == "bunga" && this.form.bunga ? this.form.bunga : 0;
        const data = {
          id: this.changeDetail.status
            ? this.changeDetail.selected.id
            : nanoid(),
          bulan: this.moment(this.form.bulan).format("M"),
          tahun: this.moment(this.form.tahun).format("YYYY"),
          type: this.form.type,
          pokok: tpokok,
          bunga: tbunga,
          total: parseFloat(tpokok) + parseFloat(tbunga),
          can_edit: "enabled"
        };
        
        if (
          parseFloat(tpokok) == 0 &&
          parseFloat(tbunga) == 0
        ) {
          this.displayMessageValue(
            "basic-error",
            "Pokok and Bunga Cannot less than 1, please fill in one!"
          );
          return;
        }

        if (this.changeDetail.status) {
          if (
            this.sisa_penarikan +
              this.changeDetail.selected.pokok -
              parseFloat(tpokok) <
            0
          ) {
            this.displayMessageValue(
              "basic-error",
              "Total pokok tidak boleh lebih dari total value penarikan"
            );
            return;
          }
          this.$store.commit("editDetailPenarikan", data);
          this.changeDetail = {
            selected: {},
            status: false,
          };
        } else {
          if (this.sisa_penarikan - parseFloat(tpokok) < 0) {
            this.displayMessageValue(
              "basic-error",
              "Total pokok tidak boleh lebih dari total value penarikan"
            );
            return;
          }
          this.$store.commit("setDetail", data);
        }
        this.$store.commit("setTotalPokok", this.sum_table.total_pokok);
        this.initialState();
      });
    },
    handleDelete(item) {
      this.$store.commit("removeDetailPenarikan", item);
      this.$store.commit("setTotalPokok", this.sum_table.total_pokok);
      this.displayMessage("success-del");
    },
    handleEdit(item) {
      this.changeDetail = {
        selected: item,
        status: true,
      };

      let blnthn = moment(item.bulan).format("MM")+"-"+ moment(item.tahun).format("YYYY")
      this.form = {
        bulan: this.moment().month(parseFloat(item.bulan - 1)),
        tahun: moment(blnthn,"MM-YYYY"),
        type: item.type,
        pokok: item.pokok,
        bunga: item.bunga,
      };
    },
    handleRef() {
      if (this.changeDetail.status) {
        this.displayMessageValue(
          "basic-error",
          "Terdapat data edit yang belum anda simpan!"
        );
        return;
      }

      if (this.sisa_penarikan !== 0) {
        this.displayMessageValue("basic-error", "Sisa penarikan harus 0");
        return;
      }

      Event.$emit("dataProcessed");
    },
    handleCancel() {
      this.initialState();
      this.changeDetail = {
        selected: {},
        status: false,
      };
    },
    changeyear(val) {
      this.form.bulan = val
    }
  },
};
</script>

<style lang="less" scoped>
.table-footer {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  list-style: none;
  text-align: right;
}
</style>

<style lang="less">
.ant-calendar-panel {
  z-index: 10;
}
</style>
